import { Injectable } from '@tanbo/vue-di-plugin'
import { TableList, TableMemoryPagination } from '@/services/table-memory-pagination'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 终端设备id */
  device_id: string
  /** 排序类型,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段，默认是device_count */
  sort?: string
  /** 是否使用内存数据 */
  useMemory: boolean
}

export interface RuleItem {
  /** 阻断规则id */
  rule_id: number
  /** 阻断端口起点 */
  port_start: number
  /** 阻断端口终点 */
  port_end: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 系统类型 1-windows 2-linux 3-win server */
  system_type: number
}

export interface RelieveParams {
  /** 终端设备id */
  device_id: string
  /** 选择类型, 1-指定规则,2-终端关联全部规则 */
  select_type: number
  /** 规则id列表 */
  rule_id_list: number[]
}

@Injectable()
export class PortListDrawerService extends TableMemoryPagination<QueryParams, RuleItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: RuleItem, right: RuleItem): boolean {
    return left.rule_id === right.rule_id
  }

  @ParamsClean()
  getListByServer (params: QueryParams): Promise<TableList<RuleItem>> {
    return this.http.post<{
      list: RuleItem[]
      total: number
    }>('/portcontrol/device-blocked-rule/list', params)
  }

  doPortcontrolDeviceBlockedRulesCancel (data: RelieveParams) {
    return this.http.post<{
      /** 下发任务id */
      task_id: string
    }>('/portcontrol/device-blocked-rules/cancel', data)
  }
}
